import Modal from "@mui/material/Modal";
import { useState } from "react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useHistory } from "react-router-dom";
export default function UnSubScribe(props) {
  const history = useHistory();
  const [open, setOpen] = useState(true);
  const [status, setStatus] = useState(false);
  const { mail,id } = props.match.params;
  function unsubscribeUser() {
    let unsubData = {
      email: mail,
      reason: "not good",
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/automation/post-unsubscribe-details/${id}`,
        { data: JSON.stringify(unsubData) }
      )
      .then((res) => {
        if (res.data.status) {
            setStatus(true)
        } else {
            setStatus(false)
        }
      })
      .catch((err) => console.log("Error"));
  }
  return (
    <div>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          className="modalPopupUnsubscribe"
        >
          {status ? (
            <>
              <div
                className="modaltext"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Sorry to see you go!
              </div>
              <div
                className="modalsubtext"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                You have successfully unsubscribed from all communication.
              </div>
            </>
          ) : (
            <>
              <div
                className="modaltext"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Unsubscribe
              </div>
              <div
                className="modalsubtext"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                You’re email address {mail}
              </div>
              <div
                className="modalsubtext"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Are you sure you’d like to stop receiving emails from
                help@coldsender.com
              </div>

              <div
                style={{
                  gap: "10px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{ width: "100%" }}
                    className="continuebuttonmodal"
                    onClick={() => {
                      unsubscribeUser();
                    }}
                  >
                    Unsubscribe
                  </div>
                  <div
                    className="cancelbuttonmodal"
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    Cancel
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
}
